import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import BooksOutlineLabel from '../../../books/common/labels/BooksOutlineLabel';
import BooksCheckInput, { InputType } from '../../model1/forms/BooksCheckInput';
import BooksTimeItem from '../texts/BooksTimeItem';

import css from './BooksSelectTimeInstructor.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  startTime: string;
  endTime: string;
  instructors?: string[];
  vacancy: number;
  showVacancy: boolean;
  value: number;
  checked: boolean;
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksSelectTimeInstructor = ({
  className,
  startTime,
  endTime,
  intl,
  instructors,
  vacancy,
  showVacancy,
  value,
  checked,
  onChange,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksSelectTimeInstructor, className);
  const labelClasses = classNames(
    css.BooksSelectTimeInstructor__Label,
    { [css.isSoldOut]: !vacancy },
    className,
  );

  return (
    <div className={classes}>
      <BooksCheckInput
        type={InputType.Checkbox}
        name="select-time"
        checked={checked}
        onChange={onChange}
        disabled={vacancy < 1}
        labelClassName={css.BooksSelectTimeInstructor__Input}
        value={value}
      >
        <BooksTimeItem
          startTime={startTime}
          endTime={endTime}
          instructors={instructors}
          className={vacancy < 1 ? css.isDisabled : ''}
        />
        {vacancy > 0 ? (
          showVacancy && (
            <BooksOutlineLabel
              label={`${intl.formatMessage({
                id: 'merchants.services.status.vacancy',
              })} ${vacancy}`}
              className={labelClasses}
            />
          )
        ) : (
          <BooksOutlineLabel
            label={intl.formatMessage({
              id: 'merchants.services.status.soldOut',
            })}
            className={labelClasses}
          />
        )}
      </BooksCheckInput>
    </div>
  );
};

export default injectIntl(BooksSelectTimeInstructor);
